export default "__VITE_ASSET__DKt70yD4__"